import { render, staticRenderFns } from "./client_like_file_desc.vue?vue&type=template&id=48aae0ac&scoped=true&lang=pug&"
import script from "./client_like_file_desc.vue?vue&type=script&lang=js&"
export * from "./client_like_file_desc.vue?vue&type=script&lang=js&"
import style0 from "./client_like_file_desc.vue?vue&type=style&index=0&id=48aae0ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aae0ac",
  null
  
)

export default component.exports